// Catalog of Permits
export function LocalCatalogues() {
  //Get prefix token
  const prefix = process.env.REACT_APP_PREFIX;
  const language = localStorage.getItem(`cmLanguage${prefix}`);
  //Alphabetization of roles
  const sortByName = (arr) => {
    return arr.sort(function (a, b) {
      if (a.name > b.name) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      return 0;
    });
  };
  const userRoles = [
    {
      id: 7,
      value: 7,
      nameId: "teacher",
      name: language === "spanish" ? "Maestro" : "Teacher",
      label: language === "spanish" ? "Maestro" : "Teacher",
    },
    {
      id: 2,
      value: 2,
      nameId: "admin",
      name: language === "spanish" ? "Administrador" : "Administrator",
      label: language === "spanish" ? "Administrador" : "Administrator",
    },
    {
      id: 16,
      value: 16,
      nameId: "school_control",
      name: language === "spanish" ? "Control Escolar" : "School Control",
      label: language === "spanish" ? "Control Escolar" : "School Control",
    },
    {
      id: 18,
      value: 18,
      nameId: "caja",
      name: language === "spanish" ? "Caja" : "Cashier",
      label: language === "spanish" ? "Caja" : "Cashier",
    },
    {
      id: 19,
      value: 19,
      nameId: "comunicación",
      name: language === "spanish" ? "Comunicación" : "Communication",
      label: language === "spanish" ? "Comunicación" : "Communication",
    },
    {
      id: 20,
      value: 20,
      nameId: "staffGeneral",
      name: language === "spanish" ? "Personal General" : "Staff General",
      label: language === "spanish" ? "Personal General" : "Staff General",
    },
    {
      id: 17,
      value: 17,
      nameId: "admissions",
      name: language === "spanish" ? "Admisiones" : "Admissions",
      label: language === "spanish" ? "Admisiones" : "Admissions",
    },
  ];
  const data = {
    userRoles,
    allRoles: [
      ...userRoles,
      {
        id: 1,
        value: 1,
        nameId: "super_admin",
        name: language === "spanish" ? "Super Admin" : "Super Admin",
        label: language === "spanish" ? "Super Admin" : "Super Admin",
      },
      {
        id: 6,
        value: 6,
        nameId: "parent",
        name: language === "spanish" ? "Familiar" : "Relative",
        label: language === "spanish" ? "Familiar" : "Relative",
      },
      {
        id: 8,
        value: 8,
        nameId: "student",
        name: language === "spanish" ? "Estudiante" : "Student",
        label: language === "spanish" ? "Estudiante" : "Student",
      },
    ],
  };
  sortByName(data.userRoles);
  sortByName(data.allRoles);
  return data;
}
